import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_88: FaireProductEntity = {
  token: "catalog_prod_prod-88",
  type: "product",
  name: "Decorative Item B - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=400&h=400&fit=crop",
  priceDollars: 78.43,
  msrpDollars: 196.08,
  sku: "AN0088",
  caseSize: 12,
  material: "Cotton",
  collectionToken: "col_andean-touch",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 495,
  description: "Beautiful Andean Touch piece perfect for any home.",
  categoryTokens: ["catalog_cat_home-fragrances"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
